document.querySelectorAll('.wisco-hub:not(.wisco-hub-v2)').forEach(hub => {
  const controls = hub.querySelector('.wisco-resource-controls');
  if (!controls) return;
  const search = controls.querySelector('input');
  const buttons = [...controls.querySelectorAll('button[data-topic]')];
  const cards = [...hub.querySelectorAll('.wisco-resource')];
  const count = controls.querySelector('[role="status"]');
  const empty = hub.querySelector('.wisco-resource-empty');
  let topic = 'all';
  function update() {
    const term = search.value.trim().toLowerCase();
    let visible = 0;
    cards.forEach(card => {
      const match = (topic === 'all' || card.dataset.topic === topic) && card.textContent.toLowerCase().includes(term);
      card.hidden = !match;
      if (match) visible++;
    });
    count.textContent = `${visible} ${visible === 1 ? 'resource' : 'resources'} shown`;
    empty.hidden = visible !== 0;
  }
  buttons.forEach(button => button.addEventListener('click', () => {
    topic = button.dataset.topic;
    buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    update();
  }));
  search.addEventListener('input', update);
  controls.hidden = false;
  update();
});

document.querySelectorAll('.wisco-hub-v2').forEach(hub => {
  const controls = hub.querySelector('.wisco-resource-controls');
  if (!controls) return;
  const labels = document.getElementById('wisco-hub-labels').dataset;
  const search = controls.querySelector('input[type="search"]');
  const regions = [...controls.querySelectorAll('button[data-topic]')];
  const interest = controls.querySelector('#hub-interest');
  const cards = [...hub.querySelectorAll('[data-guide-id]')];
  const savedFilter = controls.querySelector('.hub-saved-filter');
  const count = controls.querySelector('.wisco-resource-count');
  const empty = hub.querySelector('.wisco-resource-empty');
  const share = controls.querySelector('.hub-share');
  const shareStatus = controls.querySelector('.hub-share-status');
  const summary = controls.querySelector('.hub-filter-summary');
  const shell = hub.closest('.hub-page-shell');
  const nav = shell?.querySelector('.hub-subnav');
  const key = 'wisco-hub-saved-guides-v1';
  let region = 'all';
  let onlySaved = false;
  let saved = new Set();
  let persistent = true;
  try {
    const value = JSON.parse(localStorage.getItem(key) || '[]');
    if (Array.isArray(value)) saved = new Set(value.filter(id => cards.some(card => card.dataset.guideId === id)));
  } catch { persistent = false; }
  function readView() {
    const params = new URLSearchParams(location.search);
    region = regions.some(button => button.dataset.topic === params.get('region')) ? params.get('region') : 'all';
    interest.value = [...interest.options].some(option => option.value === params.get('interest')) ? params.get('interest') : 'all';
    search.value = params.get('q') || '';
    onlySaved = params.get('saved') === '1';
  }
  function writeView(replace = false, hash = '#wisconsin-guides') {
    const url = new URL(location.href);
    for (const name of ['region', 'interest', 'q', 'saved']) url.searchParams.delete(name);
    if (region !== 'all') url.searchParams.set('region', region);
    if (interest.value !== 'all') url.searchParams.set('interest', interest.value);
    if (search.value.trim()) url.searchParams.set('q', search.value.trim());
    if (onlySaved) url.searchParams.set('saved', '1');
    url.hash = hash;
    if (url.href !== location.href) history[replace ? 'replaceState' : 'pushState'](null, '', url);
  }
  function update() {
    const term = search.value.trim().toLowerCase();
    let shown = 0;
    cards.forEach(card => {
      const match = (region === 'all' || card.dataset.topic === region)
        && (interest.value === 'all' || card.dataset.interest === interest.value)
        && (!onlySaved || saved.has(card.dataset.guideId))
        && card.textContent.toLowerCase().includes(term);
      card.hidden = !match;
      if (match) shown++;
      const button = card.querySelector('.hub-save');
      const isSaved = saved.has(card.dataset.guideId);
      button.setAttribute('aria-pressed', String(isSaved));
      button.textContent = isSaved ? labels.saved : labels.save;
      button.setAttribute('aria-label', `${isSaved ? labels.remove : labels.save} ${card.querySelector('h3').textContent}`);
    });
    regions.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.topic === region)));
    count.textContent = `${shown} ${shown === 1 ? labels.one : labels.many} ${labels.shown}`;
    controls.querySelector('[data-saved-count]').textContent = saved.size;
    savedFilter.setAttribute('aria-pressed', String(onlySaved));
    empty.hidden = shown !== 0;
    share.hidden = onlySaved;
    const active = [];
    if (region !== 'all') active.push(regions.find(button => button.dataset.topic === region).textContent);
    if (interest.value !== 'all') active.push(interest.selectedOptions[0].textContent);
    if (onlySaved) active.push(labels.savedView);
    if (term) active.push(`${labels.search}: ${search.value.trim()}`);
    summary.textContent = active.length ? active.join(' · ') : labels.all;
    shareStatus.hidden = true;
    if (!persistent) controls.querySelector('.hub-save-note').textContent = labels.session;
  }
  function reset() {
    region = 'all'; onlySaved = false; interest.value = 'all'; search.value = '';
  }
  function revealGuide() {
    const card = cards.find(item => `#${item.id}` === location.hash);
    if (!card) return;
    if (card.hidden) { reset(); update(); writeView(true, `#${card.id}`); }
    const fieldNotes = card.closest('.wisco-field-notes');
    if (fieldNotes) fieldNotes.open = true;
    card.querySelector('details').open = true;
    card.scrollIntoView({block: 'start'});
  }
  regions.forEach(button => button.addEventListener('click', () => {
    region = button.dataset.topic; update(); writeView();
  }));
  cards.forEach(card => card.querySelector('.hub-save').addEventListener('click', () => {
    const id = card.dataset.guideId;
    saved.has(id) ? saved.delete(id) : saved.add(id);
    try { localStorage.setItem(key, JSON.stringify([...saved])); } catch { persistent = false; }
    update();
  }));
  savedFilter.addEventListener('click', () => { onlySaved = !onlySaved; update(); writeView(); });
  controls.querySelector('.hub-reset').addEventListener('click', () => { reset(); update(); writeView(); });
  search.addEventListener('input', () => { update(); writeView(true); });
  interest.addEventListener('change', () => { update(); writeView(); });
  share.addEventListener('click', async () => {
    writeView(true);
    const url = new URL(location.href);
    for (const name of ['preview_theme_id', '_ab', '_fd', '_sc']) url.searchParams.delete(name);
    try { await navigator.clipboard.writeText(url.href); shareStatus.textContent = labels.copy; }
    catch { shareStatus.textContent = labels.copyFailed; }
    shareStatus.hidden = false;
  });
  nav?.querySelector('[data-hub-saved-link]')?.addEventListener('click', event => {
    event.preventDefault(); reset(); onlySaved = true; update(); writeView();
    document.getElementById('wisconsin-guides').scrollIntoView({block:'start'});
    search.focus({preventScroll:true});
  });
  window.addEventListener('popstate', () => { readView(); update(); revealGuide(); });
  window.addEventListener('hashchange', revealGuide);
  controls.hidden = false;
  hub.querySelectorAll('[data-hub-enhanced]').forEach(element => { element.hidden = false; });
  const fieldNotes = hub.closest('.wisco-field-notes');
  const guideHash = () => {
    if (fieldNotes && /^(#wisconsin-guides|#hub-planning|#hub-outdoors|#guide-)/.test(location.hash)) fieldNotes.open = true;
  };
  guideHash();
  window.addEventListener('hashchange', guideHash);
  if (fieldNotes && ['region','interest','q','saved'].some(key => new URLSearchParams(location.search).has(key))) fieldNotes.open = true;
  readView(); update(); revealGuide();
  const header = document.getElementById('shopify-section-header');
  if (header && shell && 'ResizeObserver' in window) {
    const size = new ResizeObserver(() => shell.style.setProperty('--hub-header-height', `${header.getBoundingClientRect().height}px`));
    size.observe(header);
  }
  if (nav && 'IntersectionObserver' in window) {
    const links = [...nav.querySelectorAll('a[href^="#"]')];
    const visible = new Set();
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => entry.isIntersecting ? visible.add(entry.target.id) : visible.delete(entry.target.id));
      const first = links.find(link => visible.has(link.hash.slice(1)));
      links.forEach(link => { if (link === first) link.setAttribute('aria-current','location'); else link.removeAttribute('aria-current'); });
    }, {rootMargin:'-15% 0px -35% 0px'});
    links.forEach(link => { const target = document.getElementById(link.hash.slice(1)); if (target) observer.observe(target); });
  }
});
